import { render, staticRenderFns } from "./QuestiontypeAdd.vue?vue&type=template&id=b98d61f6&"
import script from "./QuestiontypeAdd.vue?vue&type=script&lang=ts&"
export * from "./QuestiontypeAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b98d61f6')) {
      api.createRecord('b98d61f6', component.options)
    } else {
      api.reload('b98d61f6', component.options)
    }
    module.hot.accept("./QuestiontypeAdd.vue?vue&type=template&id=b98d61f6&", function () {
      api.rerender('b98d61f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/questionType/QuestiontypeAdd.vue"
export default component.exports